import { h, render } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import FastTrackChevrons from './icons/FastTrackChevrons'
import InformationCircle from './icons/InformationCircle'

const SecurityWaitTimes = () => {
  const [fastTrackTime, setFastTrackTime] = useState(null)
  const [regularTime, setRegularTime] = useState(null)

  const fetchTimes = async () => {
    const response = await fetch('/api/v1/security-wait-times')
    const body = await response.json()

    setFastTrackTime(body.data.fast_track)
    setRegularTime(body.data.regular)
  }

  useEffect(() => {
    fetchTimes()

    setInterval(() => {
      fetchTimes()
    }, 1000 * 60)
  }, [])

  const formatWaitTime = seconds =>
    seconds !== null ? Math.round(seconds / 60) + ' mins' : ''

  return (
    <div className="flex flex-col items-center justify-center h-full py-3 text-xs uppercase sm:flex-row">
      <div className="flex flex-row items-center h-6 mb-2 sm:mb-0">
        <InformationCircle className="w-6 h-6 text-grey" />
        <span className="ml-2">Est. Security wait times</span>
      </div>
      <div className="flex flex-row sm:ml-6">
        <div className="flex flex-row items-center h-6">
          <FastTrackChevrons className="w-6 h-6" />
          <span className="ml-2">Fast Track:</span>
          <span className="ml-2 text-sm">
            {formatWaitTime(fastTrackTime)}
          </span>
        </div>
        <div className="flex flex-row items-center h-6 ml-6">
          <span>Regular:</span>
          <span className="ml-2 text-sm">
            {formatWaitTime(regularTime)}
          </span>
        </div>
      </div>
    </div>
  )
}

export default SecurityWaitTimes



// WEBPACK FOOTER //
// ./src/js/components/SecurityWaitTimes.js